
// This file was auto-generated by generate-environment.js script.
export const environment = {
  production: false,
  apiGateway: 'https://ekw9w6rkw9.execute-api.us-east-1.amazonaws.com',
  operatingCompany: '9d08e8a0-3c80-4128-b19d-3e523ca53d11',
  oauthUrl: 'https://efleet-dev.auth.us-east-1.amazoncognito.com/login',
  oauthClientId: '411pc6pu1a4hud4131e2vsn3mq',
  recaptchaKey: '6Ld_FuMjAAAAANxcU2L6DqFt1JWTU8BE9yFvk-Dp',
  mapStyleKey: 'dJ79rTjSVA6TuEokvMvI',
  chargersLocationKey: 'nN9tkZTuXcyYdHju4y6pDFe9yUi9fux9KeZ47gdA'
};
